module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0064.jpg?v=7fe9b83d";